import supabase from "./supabase";

/* // Function to get all tasks from the taskManager_history table
export async function getTasks() {
  const { data, error } = await supabase
    .from("taskManager_history")
    .select("*")
    .order("id", { ascending: true }); // Order by the 'id' column in ascending order

  if (error) {
    console.error("Error loading tasks:", error);
    throw new Error("Could not load tasks");
  }

  return data;
} */

// Function to get tasks from the taskManager_history table filtered by date only
export async function getTasks(date) {
  const { data, error } = await supabase
    .from("taskManager_history")
    .select("*")
    .eq("checkinTime::date", date) // Filter records by date only, excluding time
    .order("id", { ascending: true }); // Order by the 'id' column in ascending order

  if (error) {
    console.error("Error loading tasks:", error);
    throw new Error("Could not load tasks");
  }

  return data;
}

// Function to delete a task by ID
export async function deleteTask(id) {
  const { error } = await supabase
    .from("taskManager_history")
    .delete()
    .eq("id", id); // Delete row where column "id" equals the given ID

  if (error) {
    console.error("Error deleting task:", error);
    throw new Error("Could not delete task");
  }

  return { success: true };
}

// Function to create or edit a task
export async function createEditTask(newTask) {
  const { id, ...taskData } = newTask; // Destructure to separate id from the rest of the task data
  let data, error;

  if (id) {
    // Edit an existing task
    ({ data, error } = await supabase
      .from("taskManager_history")
      .update(taskData)
      .eq("id", id)
      .select()
      .single());
  } else {
    // Create a new task
    ({ data, error } = await supabase
      .from("taskManager_history")
      .insert([taskData])
      .select()
      .single());
  }

  if (error) {
    console.error("Error creating or editing task:", error);
    throw new Error("Could not create or edit task");
  }

  return data;
}

/** Format a Date as YYYY-MM-DD in local time. */
export function formatLocalDate(date) {
  return date.toLocaleDateString("en-CA");
}

/**
 * Distinct checkin dates that have at least one history row in [startDate, endDate].
 * @param {string} startDate YYYY-MM-DD
 * @param {string} endDate YYYY-MM-DD
 * @returns {Promise<string[]>} unique YYYY-MM-DD strings
 */
export async function getHistoryDatesInRange(startDate, endDate) {
  const { data, error } = await supabase
    .from("taskManager_history")
    .select("checkinTime")
    .gte("checkinTime", startDate)
    .lte("checkinTime", endDate);

  if (error) {
    console.error("Error loading history dates:", error);
    throw new Error("Could not load history dates");
  }

  const unique = new Set();
  for (const row of data || []) {
    const raw = row.checkinTime;
    if (!raw) continue;
    const key =
      typeof raw === "string"
        ? raw.slice(0, 10)
        : formatLocalDate(new Date(raw));
    unique.add(key);
  }

  return Array.from(unique);
}

/** Inclusive date range covering a calendar month plus padding for adjacent-month cells. */
export function getMonthQueryRange(monthDate, padDays = 7) {
  const year = monthDate.getFullYear();
  const month = monthDate.getMonth();
  const start = new Date(year, month, 1 - padDays);
  const end = new Date(year, month + 1, padDays);
  return {
    startDate: formatLocalDate(start),
    endDate: formatLocalDate(end),
  };
}
